import styled from "styled-components";

export const SelectedParticipantResultWrapper = styled.div`
  .cell {
    min-widh: 200px;
  }
  .programName {
    width: 200px;
    margin-bottom: 7px;
  }
`;
